import { MutationCache, QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { apiErrorMessage } from './apiError';
import { showErrorToast } from './errorToast';
export const queryClient = new QueryClient({
    // Gestion d'erreur par défaut : toute mutation sans `onError` propre affiche
    // le message de l'API, pour qu'aucun échec d'enregistrement ne passe inaperçu.
    mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
            if (mutation.options.onError || mutation.meta?.inlineError)
                return;
            // Espace bloqué : l'intercepteur axios renvoie déjà à la connexion.
            const code = isAxiosError(error) ? error.response?.data?.code : null;
            if (code === 'AGENT_BLOCKED' || code === 'PRO_BLOCKED')
                return;
            showErrorToast(apiErrorMessage(error));
        },
    }),
    defaultOptions: {
        queries: {
            staleTime: 30000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});
